import type { Step } from "../script";

export const openingHook: Step[] = [
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "portfolio" },
    pauseAfter: 900,
  },
  {
    kind: "msg",
    id: "msg-00-a",
    tokens:
      "portfolio vamp is in visa's healthy band — holding under 0.5%.",
    pauseAfter: 1400,
  },
  {
    kind: "msg",
    id: "msg-00-b",
    tokens:
      "that matters: above 0.5%, visa charges you $8 per cnp transaction. at 0.7%, enhanced monitoring kicks in too.",
    pauseAfter: 1500,
  },
  {
    kind: "msg",
    id: "msg-00-c",
    tokens:
      "this week i've secured €2.84m of at-risk volume for you. ytd €14.2m.",
    pauseAfter: 1400,
  },
  {
    kind: "msg",
    id: "msg-00-d",
    tokens: "here's how.",
    pauseAfter: 1100,
  },
];
